import { mutate } from 'swr';
import { useFormContext } from '@context/FormContext';
import { ApiResources, createErrorResponse, getContactData, getUrl } from '@services/utils';
import { updateProgressHistory } from '@services/progressHistory';
import { CDX_ACTIONS } from 'types/form';

export interface IProgressHistory {
  nextScreen: string;
  completedScreen: string;
}

export const useProgressHistory = (initialConfig?: IProgressHistory) => {
  const { handleStep, dispatch, submitStart, submitSuccess } = useFormContext();
  
  const updateProgress = async (runtimeConfig?: IProgressHistory) => {
    const config = runtimeConfig || initialConfig;
    
    if (!config) {
      console.error('Progress history config is required');
      return;
    }
    
    const { nextScreen, completedScreen } = config;
    const contactData = getContactData();
    
    if (!contactData?.contactId || !contactData?.leadId) return;
    
    submitStart();
    
    try {
      const data = {
        contactId: contactData.contactId,
        leadId: contactData.leadId,
        nextScreen,
        completedScreen,
      };
      
      await mutate(`${getUrl(ApiResources.progressHistory)}`, () => updateProgressHistory(data), false);
      
      handleStep(nextScreen);
      submitSuccess();
    } catch (error) {
      dispatch({
        type: CDX_ACTIONS.SUBMIT_API_ERROR,
        payload: createErrorResponse(
          error instanceof Error ? error.name : 400, 
          error instanceof Error ? error.message : ''
        ),
      });
    }
  };
  
  return [updateProgress] as const;
};